import React from 'react';
export const MailSvg: React.FC = () => {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 16.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1203_3301)">
        <path
          d="M18.5764 0H2.67363C1.96454 0 1.28449 0.282147 0.783088 0.784371C0.281685 1.28659 0 1.96776 0 2.67801V14.322C0 15.0322 0.281685 15.7134 0.783088 16.2156C1.28449 16.7179 1.96454 17 2.67363 17H18.5764C19.2855 17 19.9655 16.7179 20.4669 16.2156C20.9683 15.7134 21.25 15.0322 21.25 14.322V2.67801C21.25 1.96776 20.9683 1.28659 20.4669 0.784371C19.9655 0.282147 19.2855 0 18.5764 0ZM2.67363 1.0712H18.5764C18.9812 1.07003 19.3712 1.22332 19.6672 1.49991C19.9632 1.77649 20.1429 2.15561 20.1699 2.56018C17.5283 3.97417 14.8761 5.37744 12.2238 6.79143C11.865 7.01666 11.4854 7.20678 11.0902 7.35917C10.78 7.42049 10.4602 7.41496 10.1523 7.34293C9.84436 7.27089 9.55526 7.13402 9.30423 6.9414C7.78561 6.138 6.26699 5.32388 4.75906 4.52048C3.53988 3.87776 2.29932 3.22432 1.08015 2.57089C1.10495 2.1646 1.28369 1.78312 1.57985 1.50439C1.87601 1.22567 2.26725 1.07072 2.67363 1.0712ZM20.1805 14.322C20.1805 14.7481 20.0115 15.1568 19.7107 15.4582C19.4099 15.7595 19.0018 15.9288 18.5764 15.9288H2.67363C2.24817 15.9288 1.84015 15.7595 1.5393 15.4582C1.23846 15.1568 1.06945 14.7481 1.06945 14.322V3.7867C3.59336 5.115 6.10657 6.46471 8.63047 7.80372C9.08141 8.08064 9.56685 8.29674 10.0742 8.44644C10.8168 8.56738 11.5779 8.4111 12.2131 8.00725C13.7638 7.19313 15.3039 6.36831 16.8546 5.55419C17.9668 4.95432 19.0683 4.37587 20.1805 3.7867V14.322Z"
          fill="#535761"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_3301">
          <rect width="22" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
